<template>
    <div class="step-block__nav">
        <div class="step-block__nav__item" v-bind:class="{active: currentStep === 'delivery'}" @click="setStep('delivery')"><span>1. Доставка</span></div>
        <div class="step-block__nav__item" v-bind:class="{active: currentStep === 'payment'}" @click="setStep('payment')"><span>2. Оплата</span></div>
        <div class="step-block__nav__item" v-bind:class="{active: currentStep === 'final'}" @click="setStep('final')"><span>3. Подтверждение</span></div>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex';

    export default {
        name: 'StepsPanel',
        data() {
            return {

            }
        },
        computed: {
            ...mapGetters('StoreCheckout', ['currentStep']),
        },
        methods: {
            ...mapActions('StoreCheckout', ['setStep']),
        },
    }
</script>